export { default as Img200 } from './processed/200/Wolves.jpg';
export { default as Img400 } from './processed/400/Wolves.jpg';
export { default as Imgthumb } from './processed/thumb/Wolves.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Wolves.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Wolves.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      182,
      35,
      38
    ],
    "_population": 286,
    "_hsl": [
      0.9965986394557823,
      0.6774193548387095,
      0.4254901960784314
    ]
  },
  "LightVibrant": {
    "_rgb": [
      228,
      186,
      173
    ],
    "_population": 101,
    "_hsl": [
      0.039393939393939335,
      0.5045871559633027,
      0.7862745098039217
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      118,
      22,
      25
    ],
    "_population": 224,
    "_hsl": [
      0.9947916666666666,
      0.6857142857142856,
      0.27450980392156865
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      113,
      89
    ],
    "_population": 325,
    "_hsl": [
      0.05882352941176469,
      0.27642276422764234,
      0.4823529411764706
    ]
  },
  "LightMuted": {
    "_rgb": [
      212,
      199,
      170
    ],
    "_population": 164,
    "_hsl": [
      0.11507936507936506,
      0.3281250000000002,
      0.7490196078431373
    ]
  },
  "DarkMuted": {
    "_rgb": [
      69,
      40,
      35
    ],
    "_population": 3097,
    "_hsl": [
      0.024509803921568613,
      0.32692307692307687,
      0.20392156862745098
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Wolves.js